export const QA_ROLES = Object.freeze([
    'qa',
    'senior qa',
    'expert qa',
]);

const QA_ROLE_SET = new Set(QA_ROLES);

export function normalizeUserRole(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

export function isQaRole(value) {
    return QA_ROLE_SET.has(normalizeUserRole(value));
}

export function resolveQaRole(qaRole, legacyUserRole = '') {
    const normalizedQaRole = normalizeUserRole(qaRole);
    if (QA_ROLE_SET.has(normalizedQaRole)) return normalizedQaRole;

    const normalizedLegacyRole = normalizeUserRole(legacyUserRole);
    return QA_ROLE_SET.has(normalizedLegacyRole) ? normalizedLegacyRole : '';
}

export function getQaRoleFromUserData(userData) {
    return resolveQaRole(userData?.qa_role, userData?.user_role);
}

export function getAccountRoleFromUserData(userData) {
    const normalizedRole = normalizeUserRole(userData?.user_role);
    return QA_ROLE_SET.has(normalizedRole) ? '' : normalizedRole;
}
